import { render, staticRenderFns } from "./InitialLayout.vue?vue&type=template&id=219e197c&scoped=true"
import script from "./InitialLayout.vue?vue&type=script&lang=js"
export * from "./InitialLayout.vue?vue&type=script&lang=js"
import style0 from "./InitialLayout.vue?vue&type=style&index=0&id=219e197c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e197c",
  null
  
)

export default component.exports